import logo from "@/assets/logo.jpeg";

export const LOGO = logo;

export const WHATSAPP_NUMBER = "918920818689";
export const WHATSAPP_DISPLAY = "+91 8920818689";
export const WHATSAPP_MESSAGE =
  "Hi Digital Advyzer, I'm interested in your services. I'd like to discuss a project.";
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
  WHATSAPP_MESSAGE,
)}`;

export const NAV_LINKS = [
  { label: "Home", id: "home" },
  { label: "Services", id: "services" },
  { label: "Process", id: "process" },
  { label: "Why Us", id: "why-us" },
  { label: "FAQ", id: "faq" },
  { label: "Contact", id: "contact" },
];

export const SERVICE_OPTIONS = [
  "Website Development",
  "AI Video Ads",
  "AI Automations",
];

export const SERVICES = [
  {
    id: "web-dev",
    num: "01",
    badge: "WEBSITE DEVELOPMENT",
    name: "Website Development",
    title: "Websites that make an impression.",
    description:
      "Fast, responsive and conversion-focused websites designed to turn visitors into customers.",
    features: [
      "Custom UI/UX",
      "Responsive development",
      "Performance focused",
      "SEO-ready structure",
      "Conversion-focused",
    ],
    cta: "Build My Website",
    accent: "#2563EB",
    accent2: "#7C3AED",
    tint: "#EEF2FF",
  },
  {
    id: "ai-video",
    num: "02",
    badge: "AI VIDEO ADS",
    name: "AI Video Ads",
    title: "Ads made to stop the scroll.",
    description:
      "Create attention-grabbing AI-powered video advertisements designed for modern social platforms and campaigns.",
    features: [
      "AI-powered visuals",
      "Short-form ads",
      "Product creatives",
      "Social-ready formats",
      "Creative variations",
    ],
    cta: "Create AI Ads",
    accent: "#FF6B35",
    accent2: "#7C3AED",
    tint: "#FFF1EB",
  },
  {
    id: "ai-automation",
    num: "03",
    badge: "AI AUTOMATIONS",
    name: "AI Automations",
    title: "Let your business run smarter.",
    description:
      "Connect your tools, automate repetitive work and build AI-powered workflows that save time.",
    features: [
      "Workflow automation",
      "AI processes",
      "Lead handling",
      "Notifications",
      "Custom integrations",
    ],
    cta: "Automate My Business",
    accent: "#2563EB",
    accent2: "#65A30D",
    tint: "#F3FAE6",
  },
];

export const WHY_US = [
  { num: "01", title: "AI-First", desc: "Use AI where it creates a real advantage.", color: "#2563EB" },
  { num: "02", title: "Built To Convert", desc: "Beautiful experiences with business goals behind them.", color: "#FF6B35" },
  { num: "03", title: "Modern By Default", desc: "Fast, responsive and built with modern technology.", color: "#7C3AED" },
  { num: "04", title: "No Unnecessary Services", desc: "We focus on the three things we do best.", color: "#65A30D" },
];

export const PROCESS = [
  { step: "01", name: "Discover", desc: "We understand your business, goals and requirements.", color: "#2563EB" },
  { step: "02", name: "Plan", desc: "We define the strategy, structure and technology required.", color: "#7C3AED" },
  { step: "03", name: "Build", desc: "We design and develop the solution.", color: "#FF6B35" },
  { step: "04", name: "Launch", desc: "We test, optimize and launch.", color: "#65A30D" },
  { step: "05", name: "Improve", desc: "We improve the system based on real-world performance.", color: "#2563EB" },
];

export const FAQS = [
  {
    q: "What services does Digital Advyzer provide?",
    a: "We focus on exactly three things: website development, AI-powered video advertisements and AI business automations. That focus is deliberate — it lets us do each one exceptionally well.",
  },
  {
    q: "Can you build a completely custom website?",
    a: "Yes. Every website we build is custom-designed and custom-coded around your goals — no rigid templates. We focus on responsive layouts, modern animations and conversion-focused structure.",
  },
  {
    q: "How does AI video advertising work?",
    a: "We use AI tools to generate visuals, assist creative direction and produce short-form product and brand video ads optimized for social platforms — with multiple creative variations to test what performs.",
  },
  {
    q: "What kind of business automations can you build?",
    a: "Lead capture and qualification, CRM updates, notifications, data handling and custom AI-powered workflows that connect your existing tools and remove repetitive manual work.",
  },
  {
    q: "Can you integrate AI with my existing tools?",
    a: "Yes. We build custom integrations that connect your current stack — CRMs, messaging, email and internal tools — so your automations fit how you already work.",
  },
  {
    q: "Do you work with startups and small businesses?",
    a: "Absolutely. We work with modern businesses of all sizes, from early-stage startups to established companies looking to modernize and automate.",
  },
  {
    q: "How do I start a project?",
    a: "Send us a project request through the contact form below or message us directly on WhatsApp. Tell us what you're trying to build, automate or advertise and we'll take it from there.",
  },
  {
    q: "How can I contact Digital Advyzer?",
    a: "The fastest way is WhatsApp at +91 8920818689, or fill out the project request form below and we'll reach out to you.",
  },
];

/** Smooth-scroll to a section id, accounting for the floating navbar. */
export function scrollToId(id) {
  const el = document.getElementById(id);
  if (!el) return;
  const offset = 88;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -offset });
    return;
  }
  const top = el.getBoundingClientRect().top + window.scrollY - offset;
  window.scrollTo({ top, behavior: "smooth" });
}
